import { UserInfo } from "Infrastructure/Api/Api";
import React, { createContext, useContext } from "react";

const UserInfoContext = createContext<UserInfo | null>(null);

export const useUserInfo = () => {
	const context = useContext(UserInfoContext);
	if (!context) {
		throw new Error("useUserInfo must be used within a UserInfoProvider");
	}
	return context;
};

interface UserInfoProviderProps {
	children: React.ReactNode;
	userInfo: UserInfo | null;
}

export const UserInfoProvider: React.FC<UserInfoProviderProps> = ({
	children,
	userInfo,
}) => {
	return (
		<UserInfoContext.Provider value={userInfo}>
			{children}
		</UserInfoContext.Provider>
	);
};
